import { StoreState } from "../../store/RootReducer";
import {
	useDispatch as reduxUseDispatch,
	useSelector as reduxUseSelector,
} from "react-redux";
import store from "store";

export const useDispatch = reduxUseDispatch;

export const useSelector = <T>(
	mapStateToProps: (state: StoreState) => T,
	options?: { forceFresh: boolean },
): T => {
	const value = reduxUseSelector(mapStateToProps);
	if (typeof value !== "object") {
		throw new Error("Return object from useSelector func");
	}
	// fixes a strange issue where state won't update in the InviteDriversForm
	if (options?.forceFresh) {
		return mapStateToProps(store.getState());
	}
	return value;
};
